
import {serializable, alias, primitive} from 'serializr';

export class OrganizationMetaData { 

	@serializable(alias('id', primitive()))
	value?: number;

	@serializable(alias('name', primitive()))
	label?: string;
}